import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/PrincipalPage.html?vue&type=template&id=5b6c5348&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/PrincipalPage.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/PrincipalPage.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/principalPage.scss?vue&type=style&index=0&id=5b6c5348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c5348",
  null
  
)

export default component.exports